export default {"src":"/_next/static/media/led.14a2e33b.gif","height":250,"width":420,"blurWidth":0,"blurHeight":0};